<template>
  <div class="d-flex flex-column align-center pt-12">
    <h1 class="headline align-self-center">Search for a test</h1>
    <v-card width="1000" class="mt-5">
      <v-card-title>
        <div class="d-flex align-center justify-end flex-grow-1">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            class="flex-grow-0"
            label="Search"
            v-model="search"
          ></v-text-field>
          <v-btn tile depressed color="primary" class="buttonText ml-2">Search by Date</v-btn>
          <v-btn
            tile
            depressed
            color="primary"
            class="buttonText ml-2"
            @click="searchByCode"
          >Search by code</v-btn>
          <v-btn tile depressed color="primary" class="buttonText ml-2" @click="getAll">Show All</v-btn>
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="items"
          :sort-by="['interviewDate']"
          :sort-desc="[true]"
        >
          <template
            v-slot:item.interviewDate="{ item }"
          >{{ convertDateWithHour(item.interviewDate) }}</template>
          <template v-slot:item.result={item}>
            <span :class="outcomeClass(item.result)">{{item.result}}</span>
          </template>
          <template v-slot:item.actions="{item}">
            <v-btn icon @click="selectedCase = item; dialog = true">
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column">
            <v-text-field readonly label="Date of Interview" :value="selectedCase.interviewDate"></v-text-field>
            <v-text-field readonly label="Company code" :value="selectedCase.orgCode"></v-text-field>
            <p class="headline black--text">1. Patient profile</p>
            <v-text-field readonly label="First Name" :value="selectedCase.firstName"></v-text-field>
            <v-text-field readonly label="Last name" :value="selectedCase.lastName"></v-text-field>
            <v-text-field
              readonly
              label="Middle name"
              :value="selectedCase.formJsonText.patientProfile.middleName"
            ></v-text-field>
            <v-text-field
              readonly
              label="Birthday"
              :value="selectedCase.formJsonText.patientProfile.birthDay"
            ></v-text-field>
            <v-text-field
              readonly
              label="Age"
              :value="selectedCase.formJsonText.patientProfile.age"
            ></v-text-field>
            <v-text-field
              readonly
              label="Sex"
              :value="selectedCase.formJsonText.patientProfile.sex"
            ></v-text-field>
            <v-text-field
              readonly
              label="Occupation"
              :value="selectedCase.formJsonText.patientProfile.occupation"
            ></v-text-field>
            <v-text-field
              readonly
              label="Civil Status"
              :value="selectedCase.formJsonText.patientProfile.civilStatus"
            ></v-text-field>
            <v-text-field
              readonly
              label="Nationality"
              :value="selectedCase.formJsonText.patientProfile.nationality"
            ></v-text-field>
            <v-text-field readonly label="PasportNo" :value="selectedCase.passportNo"></v-text-field>

            <p class="headline black--text">2.1 Permanent Address</p>
            <v-text-field
              readonly
              label="House No./Lot/Bldg"
              :value="selectedCase.formJsonText.permanentAddress.houseNo"
            ></v-text-field>
            <v-text-field
              readonly
              label="Street/Barangay"
              :value="selectedCase.formJsonText.permanentAddress.street"
            ></v-text-field>
            <v-text-field
              readonly
              label="Municipality"
              :value="selectedCase.formJsonText.permanentAddress.municipality"
            ></v-text-field>
            <v-text-field
              readonly
              label="City"
              :value="selectedCase.formJsonText.permanentAddress.city"
            ></v-text-field>
            <v-text-field
              readonly
              label="Province"
              :value="selectedCase.formJsonText.permanentAddress.province"
            ></v-text-field>
            <v-text-field
              readonly
              label="Region"
              :value="selectedCase.formJsonText.permanentAddress.region"
            ></v-text-field>
            <v-text-field
              readonly
              label="Home Phone No."
              :value="selectedCase.formJsonText.permanentAddress.homePhoneNo"
            ></v-text-field>
            <v-text-field
              readonly
              label="Cellphone No."
              :value="selectedCase.formJsonText.permanentAddress.cellPhoneNo"
            ></v-text-field>

            <p class="headline black--text">2.2 Current Address</p>
            <v-text-field
              readonly
              label="House No./Lot/Bldg"
              :value="selectedCase.formJsonText.currentAddress.houseNo"
            ></v-text-field>
            <v-text-field
              readonly
              label="Street/Barangay"
              :value="selectedCase.formJsonText.currentAddress.street"
            ></v-text-field>
            <v-text-field
              readonly
              label="Municipality"
              :value="selectedCase.formJsonText.currentAddress.municipality"
            ></v-text-field>
            <v-text-field
              readonly
              label="City"
              :value="selectedCase.formJsonText.currentAddress.city"
            ></v-text-field>
            <v-text-field
              readonly
              label="Province"
              :value="selectedCase.formJsonText.currentAddress.province"
            ></v-text-field>
            <v-text-field
              readonly
              label="Region"
              :value="selectedCase.formJsonText.currentAddress.region"
            ></v-text-field>
            <v-text-field
              readonly
              label="Home Phone No."
              :value="selectedCase.formJsonText.currentAddress.homePhoneNo"
            ></v-text-field>
            <v-text-field
              readonly
              label="Cellphone No."
              :value="selectedCase.formJsonText.currentAddress.cellPhoneNo"
            ></v-text-field>
            <v-text-field
              readonly
              label="Other Email Address"
              :value="selectedCase.formJsonText.currentAddress.otherEmail"
            ></v-text-field>

            <p class="headline black--text">3. Address Outside the Phillipines</p>
            <v-text-field
              readonly
              label="Employer's Name"
              :value="selectedCase.formJsonText.addressOutside.employersName"
            ></v-text-field>
            <v-text-field
              readonly
              label="Occupation"
              :value="selectedCase.formJsonText.addressOutside.occupation"
            ></v-text-field>
            <v-text-field
              readonly
              label="Place of work"
              :value="selectedCase.formJsonText.addressOutside.placeOfWork"
            ></v-text-field>
            <v-text-field
              readonly
              label="House No./Bldg Name"
              :value="selectedCase.formJsonText.addressOutside.houseNo"
            ></v-text-field>
            <v-text-field
              readonly
              label="Street"
              :value="selectedCase.formJsonText.addressOutside.street"
            ></v-text-field>
            <v-text-field
              readonly
              label="Municipality"
              :value="selectedCase.formJsonText.addressOutside.municipality"
            ></v-text-field>
            <v-text-field
              readonly
              label="City"
              :value="selectedCase.formJsonText.addressOutside.city"
            ></v-text-field>
            <v-text-field
              readonly
              label="Province"
              :value="selectedCase.formJsonText.addressOutside.province"
            ></v-text-field>
            <v-text-field
              readonly
              label="Country"
              :value="selectedCase.formJsonText.addressOutside.country"
            ></v-text-field>
            <v-text-field
              readonly
              label="Office Phone No"
              :value="selectedCase.formJsonText.addressOutside.officePhoneNo"
            ></v-text-field>
            <v-text-field
              readonly
              label="Cellphone No"
              :value="selectedCase.formJsonText.addressOutside.cellPhoneNo"
            ></v-text-field>

            <!-- <p class="headline black--text">4. Travel History</p>
            <v-radio-group
              readonly
              label="History of travel/visit/work in other countries with a known COVID-19 transmission 14 days before the onset of your signs and symptoms"
              :value="selectedCase.formJsonText.travelHistory.visited"
            >
              <v-radio label="Yes" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
            <v-text-field
              readonly
              label="Port(Country) of exit"
              :value="selectedCase.formJsonText.travelHistory.port"
            ></v-text-field>
            <v-text-field
              readonly
              label="Airline/Sea vessel"
              :value="selectedCase.formJsonText.travelHistory.vessel"
            ></v-text-field>
            <v-text-field readonly label="Flight/Vessel number"></v-text-field>
            <v-text-field
              readonly
              label="Date of Departure(mm/dd/yyyy)"
              :value="selectedCase.formJsonText.travelHistory.departureDate"
            ></v-text-field>
            <v-text-field
              readonly
              label="Date of Arrival in Philippines"
              :value="selectedCase.formJsonText.travelHistory.arrivalDate"
            ></v-text-field> -->

            <!-- <p class="haedline black--text">5. Exposure History</p>
            <v-radio-group
              readonly
              label="History of Exposure to Known COVID-19 editingShippingTest 14 days before the onset of signs and symptoms"
              :value="selectedCase.formJsonText.exposureHistory.history"
            >
              <v-radio label="Yes" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
              <v-radio label="Uknown" :value="null"></v-radio>
            </v-radio-group>
            <v-text-field
              readonly
              label="If Yes: Date of contant with knwon COVID-19"
              :value="selectedCase.formJsonText.exposureHistory.historyDate"
            ></v-text-field>
            <v-radio-group
              readonly
              label="Have you been in a place with a known COVID-19 transmission 14 days before the onset of signs and symptoms?"
              :value="selectedCase.formJsonText.exposureHistory.place"
            >
              <v-radio label="Yes" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
              <v-radio label="Uknown" :value="null"></v-radio>
            </v-radio-group>
            <v-radio-group
              readonly
              label="If yes: place"
              :value="selectedCase.formJsonText.exposureHistory.placeType"
            >
              <v-radio value="workPlace" label="Work Place"></v-radio>
              <v-radio value="socialGathering" label="Social gathering"></v-radio>
              <v-radio value="healthFacility" label="Health facility"></v-radio>
              <v-radio value="religiousGathering" label="Religious gathering"></v-radio>
              <v-radio value="others" label="Others"></v-radio>
            </v-radio-group>

            <v-text-field
              readonly
              label="Date of when you were in that place"
              :value="selectedCase.formJsonText.exposureHistory.placeDate"
            ></v-text-field>
            <v-text-field
              readonly
              label="Name of the place"
              :value="selectedCase.formJsonText.exposureHistory.placeName"
            ></v-text-field> -->

            <!-- <p class="haedline black--text">6. Clinical Information</p>
            <v-radio-group
              readonly
              label="Disposition at Time of report"
              :value="selectedCase.formJsonText.clinicalInformation.disposition"
            >
              <v-radio value="inpatient" label="Inpatient"></v-radio>
              <v-radio value="outpatient" label="Outpatient"></v-radio>
              <v-radio value="discharged" label="Discharged"></v-radio>
              <v-radio value="died" label="Died"></v-radio>
              <v-radio value="unknown" label="Unknown"></v-radio>
            </v-radio-group>

            <v-text-field
              readonly
              label="Date of Onset of illness (mm/dd/yyyy)"
              :value="selectedCase.formJsonText.clinicalInformation.dateOfIllness"
            ></v-text-field>
            <v-text-field
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.dateOfAddmission"
              label="Date of Addmission/Consulation (mm/dd/yyyy)"
            ></v-text-field>
            <v-text-field
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.fever"
              label="Fever"
            ></v-text-field>
            <v-checkbox
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.cough"
              class="ma-0 pa-0"
              label="Cough"
            ></v-checkbox>
            <v-checkbox
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.soreThroat"
              class="ma-0 pa-0"
              label="Sore throat"
            ></v-checkbox>
            <v-checkbox
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.colds"
              class="ma-0 pa-0"
              label="Colds"
            ></v-checkbox>
            <v-checkbox
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.breathShortness"
              class="ma-0 pa-0"
              label="Shortness/difficulty of breathing"
            ></v-checkbox>

            <v-text-field
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.otherSymptoms"
              label="Other signs/symptoms, specify"
            ></v-text-field>
            <v-radio-group
              :value="selectedCase.formJsonText.clinicalInformation.otherIllnessHistory"
              label="Is there any history of other illnes?"
            >
              <v-radio :value="true" label="Yes"></v-radio>
              <v-radio :value="false" label="No"></v-radio>
            </v-radio-group>
            <v-text-field
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.otherIllnessHistoryDescription"
              label="If Yes, specify"
            ></v-text-field>
            <v-radio-group
              :value="selectedCase.formJsonText.clinicalInformation.chestCray"
              label="Chest C-ray done?"
            >
              <v-radio :value="true" label="Yes"></v-radio>
              <v-radio :value="false" label="No"></v-radio>
            </v-radio-group>

            <v-text-field
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.chestCrayDate"
              label="If yes, when?"
            ></v-text-field>

            <v-radio-group
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.pregnant"
              label="Are you pregnant"
            >
              <v-radio :value="true" label="Yes"></v-radio>
              <v-radio :value="false" label="No"></v-radio>
            </v-radio-group>

            <v-text-field
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.lmp"
              label="LMP"
            ></v-text-field>
            <v-radio-group
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.highRisk"
              label="Assessed as High Risk?"
            >
              <v-radio :value="true" label="Yes"></v-radio>
              <v-radio :value="false" label="No"></v-radio>
            </v-radio-group>

            <v-radio-group
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.pneumonia"
              label="CXR Results: Pneumonia"
            >
              <v-radio :value="true" label="Yes"></v-radio>
              <v-radio :value="false" label="No"></v-radio>
              <v-radio :value="null" label="Pending"></v-radio>
            </v-radio-group>

            <v-text-field
              readonly
              :value="selectedCase.formJsonText.clinicalInformation.radiologicFindings"
              label="Other Radiologic Findings"
            ></v-text-field>

            <div class="d-flex flex-column" v-if="!!selectedCase.formJsonText.specimentInformation">
              <p class="headline black--text">7. Speciment Information</p>
              <v-checkbox
                readonly
                label="Serum"
                :value="selectedCase.formJsonText.specimentInformation.serum"
              ></v-checkbox>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.serumDateCollected"
                label="Date Collected(mm/dd/yyyy)"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.serumDateSentToRitm"
                label="Date Sent to RITM (mm/dd/yyyy)"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.serumDateReceivedInRitm"
                label="Date received in RITM"
                hint="to be filled up by RITM"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.serumVirusIsolationResult"
                label="Virus Isolation Result"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.serumPcrResult"
                label="PCR Result"
              ></v-text-field>

              <v-checkbox
                readonly
                label="Oropharyngeal/Nasopharungeal swab"
                :value="selectedCase.formJsonText.specimentInformation.swab"
              ></v-checkbox>

              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.swabDateCollected"
                label="Date Collected(mm/dd/yyyy)"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.swabDateSentToRitm"
                label="Date Sent to RITM (mm/dd/yyyy)"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.swabDateReceivedInRitm"
                label="Date received in RITM"
                hint="to be filled up by RITM"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.swabVirusIsolationResult"
                label="Virus Isolation Result"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.swabPcrResult"
                label="PCR Result"
              ></v-text-field>

              <v-checkbox
                label="Others"
                :value="selectedCase.formJsonText.specimentInformation.others"
              ></v-checkbox>

              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.othersDateCollected"
                label="Date Collected(mm/dd/yyyy)"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.othersDateSentToRitm"
                label="Date Sent to RITM (mm/dd/yyyy)"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.othersDateReceivedInRitm"
                label="Date received in RITM"
                hint="to be filled up by RITM"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.othersVirusIsolationResult"
                label="Virus Isolation Result"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.specimentInformation.othersPcrResult"
                label="PCR Result"
              ></v-text-field> -->
           

            <div class="d-flex flex-column" v-if="!!selectedCase.formJsonText.classification">
              <p class="headline black--text">8. Classification</p>
              <v-radio-group readonly :value="selectedCase.formJsonText.classification" label>
                <v-radio value="SUSPECTED" label="Suspected case"></v-radio>
                <v-radio value="PROBABLE" label="Probable case"></v-radio>
                <v-radio value="CONFIRMED" label="Confirmed case"></v-radio>
              </v-radio-group>

              <p class="font-weight-bold">9. Outcome</p>

              <v-radio-group
                readonly
                :value="selectedCase.formJsonText.outcome.conditionOnDischarge"
                label="Condition on Discharge"
              >
                <v-radio value="improved" label="Improved"></v-radio>
                <v-radio value="recovered" label="Recovered"></v-radio>
                <v-radio value="transferred" label="Trasferred"></v-radio>
                <v-radio value="abconded" label="Abconded"></v-radio>
                <v-radio value="died" label="Died"></v-radio>
              </v-radio-group>

              <v-text-field
                readonly
                :value="selectedCase.formJsonText.outcome.nameOfInformant"
                class="flex-grow-0 staticWidth"
                label="Name of Informant: (if patient not available)"
              ></v-text-field>
              <v-text-field
                readonly
                :value="selectedCase.formJsonText.outcome.relationship"
                class="flex-grow-0 staticWidth"
                label="Relationship"
              ></v-text-field>

              <v-text-field
                readonly
                :value="selectedCase.formJsonText.outcome.phoneNo"
                class="flex-grow-0 staticWidth"
                label="Phone No."
              ></v-text-field>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  created() {
    this.getAll();
  },

  data() {
    return {
      search: "",
      loading: false,
      dialog: false,
      selectedCase: {
        formJsonText: {
          patientProfile: {},
          permanentAddress: {},
          currentAddress: {},
          addressOutside: {},
          travelHistory: {},
          exposureHistory: {},
          clinicalInformation: {},
          specimentInformation: {},
          classification: null,
          outcome: {}
        }
      },
      headers: [
        {
          text: "id",
          value: "testId"
        },
        {
          text: "First name",
          value: "firstName"
        },
        {
          text: "Lastname",
          value: "lastName"
        },
        {
          text: "Test date",
          value: "interviewDate"
        },
        // {
        //   text: "Report type",
        //   value: "reportType"
        // },
        {
          text: 'Outcome',
          value: 'result'
        },
        {
          text: "",
          value: "actions"
        }
      ],
      items: []
    };
  },

  methods: {
    getAll() {
      this.loading = true;
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/case/`)
        .then(res => {
          this.loading = false;
          this.items = res.data;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    searchByCode() {
      this.loading = true;
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/search/case/code/${this.search}`)
        .then(res => {
          this.loading = false;
          this.items = [res.data];
          console.log(res);
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    convertDateWithHour(date) {
      return moment(new Date(date))
        .local()
        .format("DD/MM/YYYY");
      // return new Date(date)

      //return new Date(date)
    },
    outcomeClass(res){
     
      if(res == 'CONFIRMED') return 'green--text'
      // if(res == 'PENDING')
        return 'orange--text'
      //if( res=='PROBABLE') return 'orange--text'
    }
  }
};
</script>